import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.css']
})
export class CustomDialogComponent implements OnInit {

  title: string;
  closeBtnName: string;
  list: any[] = [];
  
  onClose: OnCloseModal;
  constructor( public bsModalRef: BsModalRef) {}
 
  ngOnInit() {
    //this.list.push('PROFIT!!!');
  }

  close(value: boolean) {
    this.bsModalRef.hide();
  }
  ngOnDestroy() {
    if (this.onClose)
    this.onClose(true);
  }
}

export interface OnCloseModal {
  (output: boolean): void
}
